import { Entity } from '@backstage/catalog-model';

export const isTenantManagedBy = (
  entity: Entity,
  userGroupIds: Set<string>,
): boolean => {
  const securityObjectIds: string[] =
    (entity.spec?.tenant as any)?.securityObjectIds ?? [];
  return securityObjectIds.some(id => userGroupIds.has(id.toLowerCase()));
};
